import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onClick
}: FAQItemProps) {
  return <div className="border-b border-gray-200 last:border-0" data-id="element-69">
      <button onClick={onClick} className="w-full py-6 flex justify-between items-center text-left focus:outline-none" aria-expanded={isOpen} data-id="element-70">
        <span className="font-heading text-lg md:text-xl font-bold text-brand-dark pr-8" data-id="element-71">
          {question}
        </span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="flex-shrink-0 text-brand-accent" data-id="element-72">
          <ChevronDownIcon className="w-6 h-6" data-id="element-73" />
        </motion.div>
      </button>
      <AnimatePresence initial={false} data-id="element-74">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-75">
            <p className="pb-6 text-gray-600 text-lg leading-relaxed" data-id="element-76">
              {answer}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0); // First one open by default
  const faqs = [{
    question: 'Will using an independent shop affect my warranty?',
    answer: 'No. Independent repair shops can perform maintenance and repairs without affecting your manufacturer warranty.'
  }, {
    question: 'Do independent shops have the same diagnostic tools as dealerships?',
    answer: 'Yes. Professional independent repair shops use manufacturer service data and advanced diagnostic platforms capable of servicing modern vehicles.'
  }, {
    question: 'What if the dealership recommendation is correct?',
    answer: 'Sometimes it is. Our inspection simply verifies the diagnosis so you can make an informed decision before approving an expensive repair.'
  }];
  return <section className="py-20 px-4 bg-brand-light" data-id="element-77">
      <div className="max-w-3xl mx-auto" data-id="element-78">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-79">
          <h2 className="font-heading uppercase tracking-wide text-3xl md:text-4xl font-extrabold text-brand-dark mb-4" data-id="element-80">
            Common Questions
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-white rounded-2xl border border-gray-200 shadow-sm p-6 md:p-8" data-id="element-81">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-82" />)}
        </motion.div>
      </div>
    </section>;
}